import React from 'react';
import { Row, Container, Col } from 'reactstrap';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const TestimonialPanel = ({ title, programs, viewAll }) => (
	<Container className="panel-padding">
		<Row>
			<Col md="7" sm="12" xs="12">
				<img src={`${config.cdnUrl}/static/quotes1.png`} className="testimonial-quotes" />
				<p className="testimonial-text">
					I am extremely pleased to see GiveIndia’s new platform which has an enhanced marketplace and an improved user experience.
				</p>
				<img src={`${config.cdnUrl}/static/quotes.png`} className="testimonial-quotes bottom-quote" />
			</Col>
			<Col md="5" sm="12" xs="12" style={{ paddingLeft: '4rem', paddingRight: '4rem', paddingTop: '40px' }}>
				<img src={`${config.cdnUrl}/static/testimonial-photo.jpg`} width="100%" />
				<p style={{ margin: '0', paddingTop: '0.5rem' }}>Sandeep Sibal</p>
				<p>CEO & Co-Founder, Fourth Frontier</p>
			</Col>
		</Row>
	</Container>
);

export default TestimonialPanel;
